import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { IconChevronLeft } from "@/components/icons";
import { AdminAuthActions } from "./AdminAuthActions";

export function AdminShell({
  title,
  subtitle,
  headerBelow,
  actions,
  backLink,
  compact,
  wide,
  fluid,
  hideOrganisationsNav,
  children,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  headerBelow?: ReactNode;
  actions?: ReactNode;
  backLink?: { to: string; label: string };
  compact?: boolean;
  wide?: boolean;
  fluid?: boolean;
  hideOrganisationsNav?: boolean;
  children: ReactNode;
}) {
  const titleClassName = [
    "font-unbounded font-extrabold text-ink",
    compact ? "text-xl sm:text-2xl" : "mt-1 text-2xl sm:text-3xl",
  ].join(" ");

  return (
    <div
      className={[
        "mx-auto w-full px-4 sm:px-6",
        fluid ? "max-w-none" : wide ? "max-w-7xl" : "max-w-5xl",
        compact ? "py-4 sm:py-5" : "py-5 sm:py-8",
      ].join(" ")}
    >
      <header
        className={[
          "flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between",
          compact ? "mb-4" : "mb-6",
        ].join(" ")}
      >
        <div className="min-w-0 flex-1">
          {backLink ? (
            <p className="mb-0.5 font-onest text-sm text-slate-500">
              <Link
                to={backLink.to}
                className="inline-flex items-center gap-0.5 text-brand-600 hover:text-brand-500"
              >
                <IconChevronLeft size={15} className="shrink-0" />
                {backLink.label}
              </Link>
            </p>
          ) : !compact ? (
            <p className="font-onest text-sm text-slate-500">
              <Link to="/" className="text-brand-600 hover:text-brand-500">
                Формы
              </Link>
            </p>
          ) : null}
          {typeof title === "string" ? (
            <h1 className={titleClassName}>{title}</h1>
          ) : (
            title
          )}
          {subtitle ? (
            <div
              className={[
                "font-onest text-ink-muted",
                compact ? "mt-1 text-xs text-slate-500" : "mt-2 text-base",
              ].join(" ")}
            >
              {subtitle}
            </div>
          ) : null}
          {headerBelow ? (
            <div className={compact ? "mt-2" : "mt-3"}>{headerBelow}</div>
          ) : null}
        </div>
        <div className="flex shrink-0 flex-wrap items-center gap-2">
          {actions}
          <AdminAuthActions hideOrganisationsNav={hideOrganisationsNav} />
        </div>
      </header>
      {children}
    </div>
  );
}

export {
  Checkbox,
  FieldLabel,
  SelectInput,
  SwitchControl,
  TextArea,
  TextInput,
  ToggleSwitch,
  inputClassName,
  labelClassName,
} from "./AdminFields";
